import {type ContainerType} from '@qep/types/src';

export * from './formatters.js';

/** Returns the QEP container installed on the current browser window. */
export const getContainer = (): ContainerType => globalThis.window.QEP.container;
